import { gql } from '@apollo/client';

export const gqlEncodePdfAccessToken = gql`
  query encodePdfAccessToken($key: String) {
    encodeKey(key: $key)
  }
`;

export const gqlGetCollectionOrderXrbByOrderId = gql`
  query getCollectionOrderXrbByOrderId($id: Int) {
    getCollectionOrderXrbByOrderId(id: $id) {
      id
      collectionOrderId
      msdsFileId
      bmsFileId
      techSpecFileId
      manufacturer
      partCode
      chemistry
      cellGeometry
      nominalCapacity
      nominalEnergyEfficiency
      nominalVoltage
      batteryWeight
      pieceCount
      batteryHeight
      batteryLength
      batteryWidth

      cablesSecured
      safetyPlugInstalled
      certifiedPackagingCode
      packagingCondition
      packagingHeight
      packagingLength
      packagingWidth
      replacementPackagingIsUsed
      packagingReturnRequired
      packagingDispatchDate
      packagingInstructions
      temperatureReadingRequired
      voltageReadingRequired
      packagingTypeCode
      collordPackagingReturnRequired
      wastereceptionpointId
      bmsCharacterization
      bmsCharacterizationOther
      technicianAssessment
      technicianVerifiesData
      technicianName
      technicianRegistrationNumber
      packagingForCriticallyDamaged
      carAccident
      fire
      naturalDisasters
      vandalism
      batteryLiquidCoolingSystemFailure
      noBmsData
      fireSmokeSignsSigns
      oxidationSigns
      leakageVentingSigns
      cannotDiagnose
      safetyDeviceTriggered
      additionalObservations
      easyLoadingAccess
      specialEquipmentRequired
      collectionPointHasEquipment
      equipmentDescription
      otherAccessNotes
      orgChemistry
      orgBatteryWeight
      orgPieceCount
      orgBatteryHeight
      orgBatteryLength
      orgBatteryWidth
      batteryCondition
      appropriatePackaging
      requiredPackaging
      vermiculiteUsed
      vermiculiteQuantity
      aeroplastUsed
      aeroplastQuantity
      plasticBagUsed
      plasticBagQuantity
      polyethyleneUsed
      polyethyleneQuantity
      otherMaterial
      totalRequestWeight

      msdsFileRep {
        id
        fileName
        mimeMediaType
        s3Key
      }
      bmsFileRep {
        id
        fileName
        mimeMediaType
        s3Key
      }
      techSpecFileRep {
        id
        fileName
        mimeMediaType
        s3Key
      }
      fileDetails {
        id
        collectionOrderXrbId
        fieldName
        fileId
        sortOrder
        notes
        fileRep {
          id
          fileName
          mimeMediaType
          s3Key
        }
      }
      aiFileDataExtraction
      aiIsAppropriatePackaging
      aiIsAppropriatePackagingReasoning
      aiPackagingMaterialsCalculations

      collectionOrderXrbPieceDetails {
        id
        collectionOrderXrbId
        pieceIndex
        daysOutOfOperation
        daysNotMoved
        chargeLevel
        chargeLevelDate
      }
    }
  }
`;

export const gqlGetCollectionOrderStatusHistoryByOrderId = gql`
  query getCollectionOrderXrbByOrderId($id: Int) {
    getCollectionOrderStatusHistoryByOrderId(id: $id) {
      data {
        id
        collectionOrderId
        actionDate
        notes
        oldStatus {
          id
          name
          value
        }
        newStatus {
          id
          name
          value
        }
        actionId
        collectionOrderAction {
          id
          name
          value
        }
        userId
        user {
          id
          firstName
          lastName
        }
      }
      recordCount
    }
  }
`;

export const gqlGetCollectorForCollPoint = gql`
  query getCollectorForCollectionPoint($collectionPointId: Int) {
    getCollectorForCollectionPoint(collectionPointId: $collectionPointId)
  }
`;

export const gqlGetCollPointContainers = gql`
  query getContainersOfCollectionPoint($collectionPointId: Int) {
    getContainersOfCollectionPoint(collectionPointId: $collectionPointId) {
      data {
        containerTypeId
        containerTypeName
        containersQty
      }
      recordCount
    }
  }
`;
